<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useDealsStore } from 'dashboard/stores/deals';

import SidePanelDrawer from 'dashboard/components-next/SidePanelDrawer.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import DealForm from 'dashboard/components-next/Deals/DealForm/DealForm.vue';

const emit = defineEmits(['updated']);

const { t } = useI18n();
const dealsStore = useDealsStore();

const drawerRef = ref(null);
const dealFormRef = ref(null);
const deal = ref(null);
const isSaving = ref(false);

const open = async dealId => {
  deal.value = await dealsStore.show(dealId);
  drawerRef.value?.open();
};

const handleSave = async () => {
  isSaving.value = true;
  try {
    const updated = await dealFormRef.value?.save();
    if (!updated) return;
    emit('updated', updated);
    drawerRef.value?.close();
  } finally {
    isSaving.value = false;
  }
};

defineExpose({ open });
</script>

<template>
  <SidePanelDrawer ref="drawerRef" :title="deal?.name">
    <template v-if="deal">
      <DealForm ref="dealFormRef" :deal-data="deal" />
      <div class="flex items-center w-full gap-3 mt-6">
        <Button
          :label="t('DEALS.LIST.SAVE')"
          color="blue"
          :is-loading="isSaving"
          :disabled="isSaving || dealFormRef?.isFormInvalid"
          @click="handleSave"
        />
      </div>
    </template>
  </SidePanelDrawer>
</template>
